import React, { useEffect, useState } from "react";
import styles from "../Pages/Blogs.module.css";
import { API } from "../config";

const BASE_URL = API.portfolio;

function Blogs() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedBlogId, setExpandedBlogId] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!BASE_URL) throw new Error("API URL is not configured");

        const res = await fetch(BASE_URL);

        if (!res.ok) throw new Error("Failed to fetch portfolio data");

        const data = await res.json();
        setBlogs(data.blogs || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const toggleExpand = (id) => {
    setExpandedBlogId((prev) => (prev === id ? null : id));
  };

  const formatDate = (dateStr) => {
    try {
      return new Date(dateStr).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    } catch {
      return dateStr;
    }
  };

  const truncate = (text = "", limit = 120) => {
    if (text.length <= limit) return text;
    return text.slice(0, limit).replace(/\s+\S*$/, "") + "...";
  };

  if (loading) return <p className={styles.loading}>Loading blogs...</p>;
  if (error) return <p className={styles.error}>Error: {error}</p>;
  if (!blogs.length) return <p className={styles.noBlogs}>No blogs found.</p>;

  return (
    <section id="blogs" className={styles.maincontainer}>
      <div className={styles.recent}>
        <h2 className={styles.head2}>FROM</h2>
        <h2 className={styles.pro}>MY LENS</h2>
      </div>

      <div className={styles.blogcontainer}>
        {blogs.map((blog) => {
          const paragraphs =
            blog.content
              ?.split("\n")
              .filter((p) => p.trim()) || [];

          const isExpanded = expandedBlogId === blog._id;

          return (
            <div key={blog._id} className={styles.blogcardWrapper}>
              <div
                className={styles.blogcard}
                role="button"
                tabIndex={0}
                aria-expanded={isExpanded}
                onClick={() => toggleExpand(blog._id)}
                onKeyDown={(e) =>
                  e.key === "Enter" && toggleExpand(blog._id)
                }
              >
                <div className={styles.blogimg}>
                  <img src={blog.image} alt={blog.title} />
                </div>

                <div className={styles.blogtxt}>
                  <p className={styles.bloghead}>{blog.title}</p>
                  <p className={styles.blogdes}>
                    {truncate(blog.content)}
                  </p>
                  <p className={styles.blogdate}>{formatDate(blog.date)}</p>
                </div>
              </div>

              <div
                className={`${styles.dropdown} ${
                  isExpanded ? styles.showDrop : ""
                }`}
              >
                <img
                  src={blog.image}
                  className={styles.dropImage}
                  alt={blog.title}
                />

                <div className={styles.dropText}>
                  {paragraphs.slice(0, 2).map((para, i) => (
                    <p key={i}>{para}</p>
                  ))}
                </div>

                <div className={styles.dropTextFull}>
                  {paragraphs.slice(2).map((para, i) => (
                    <p key={i}>{para}</p>
                  ))}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}

export default Blogs;